define((require) => {
    "use strict";

    const _        = require("underscore");
    const Backbone = require("backbone");
    const Locale   = require("shared/services/localization/Locale");

    const LocaleCollection = Backbone.Collection.extend("LocaleCollection", {

        model: Locale,

        /**
         * Find the Locale by its identifier(localeString) in this collection
         *
         * @param localeString
         * @returns {*}
         */
        findByLocaleString(localeString) {
            return this.find((locale) => locale.getLocaleString() === localeString);
        },

        /**
         * Giving a set of items, this method filters them out from the collection and return the rest items.
         *
         * @param locales
         * @returns {*}
         */
        remainingItems(locales) {
            return this.filter((locale) => !_.find(locales, (anotherlocale) => locale === anotherlocale));
        }
    });


    /**
     * A collection of predefined <tt>Locale</tt>'s.
     *
     * @class LocaleCollection
     */
    return new LocaleCollection([
        new Locale("zh-CN", "Chinese (CN)"),
        new Locale("da-DK", "Danish (DK)"),
        new Locale("en-GB", "English (GB)"),
        new Locale("en-US", "English (US)"),
        new Locale("fi-FI", "Finnish (FI)"),
        new Locale("fr-FR", "French (FR)"),
        new Locale("de-DE", "German (DE)"),
        new Locale("it-IT", "Italian (IT)"),
        new Locale("nb-NO", "Norwegian (NO)"),
        new Locale("pt-PT", "Portuguese (PT)"),
        new Locale("es-ES", "Spanish (ES)"),
        new Locale("sv-SE", "Swedish (SE)")
    ]);
});



// WEBPACK FOOTER //
// ./src/shared/services/localization/LocaleCollection.js